export default __webpack_public_path__ + "static/media/company.de91957f.svg";